<p-dialog
    visible="true"
    [maximizable]="false"
    [modal]="true"
    appendTo="body"
    [closable]="false"
    [style]="{ 'min-width': '25em' }"
>
    <p-header> {{ config.header }} </p-header>

    <form [formGroup]="bulkVoucherFormGroup">
        <span class="p-float-label" id="spnRemitaddridddl">
            <p-dropdown
                id="Remitaddrid"
                [options]="addresses"
                formControlName="Remitaddrid"
                [filter]="true"
                appendTo="body"
                [autoDisplayFirst]="false"
                placeholder="Remit To"
            >
            </p-dropdown>
            <label for="Remitaddrid">Remit To</label>
        </span>
        <span class="p-float-label" id="spnVoucheraddrid">
            <p-dropdown
                id="Voucheraddrid"
                [options]="addresses"
                formControlName="Voucheraddrid"
                [filter]="true"
                appendTo="body"
                [autoDisplayFirst]="false"
                placeholder="Bill To"
                [style]="{ 'min-width': '11em' }"
            >
            </p-dropdown>
            <label for="Voucheraddrid">Voucher Address</label>
        </span>
        <span class="p-float-label" id="spnFeeseparate">
            <p-checkbox
                id="Feeseparate"
                binary="true"
                [formControl]="bulkVoucherFormGroup.controls['Feeseparate']"
                #Feeseparate
            ></p-checkbox>
            <label for="Feeseparate">Separate Fee</label>
        </span>
        <span class="p-float-label" id="spnShowCN">
            <p-checkbox
                id="ShowCN"
                binary="true"
                [formControl]="bulkVoucherFormGroup.controls['ShowCN']"
                #ShowCN
            ></p-checkbox>
            <label for="ShowCN">Show Charge Numbers</label>
        </span>
        <span class="p-float-label" id="spnAccountclasstxt">
            <input
                title="Contract Description"
                pInputText
                formControlName="Vouchercontractdesc"
            />
            <label for="Vouchercontractdesc">Contract Description</label>
        </span>
    </form>
    <ng-template #footer >
        <button
            pButton
            type="button"
            class="p-button-success"
            aria-label="Apply Bulk Updates"
            [disabled]="
                bulkVoucherFormGroup.pristine || bulkVoucherFormGroup.invalid
            "
            icon="fas fa-pen-square"
            label="Update"
            (click)="dialogRef.close(bulkVoucherFormGroup.value)"
        ></button>
        <button
            pButton
            type="button"
            class="p-button-danger"
            aria-label="Cancel"
            icon="pi pi-times"
            label="Cancel"
            (click)="this.dialogRef.close()"
        ></button>
    </ng-template>
</p-dialog>
